import type { StudentGroupTeacherContactsQuery } from 'core/graphql';

export interface ITeacherContact {
  teacherId: string;
  /** Imię i nazwisko; пустая строка — у преподавателя не заполнено имя. */
  fullName: string;
  photo: string | null;
  /** `slack://user?team=<T>&id=<U>` — личка в приложении Slack. */
  slackAppUrl: string;
  /** Профиль в браузере — запасной вариант; null, пока адрес workspace не определён. */
  slackWebUrl: string | null;
}

// Ссылки собирает сервер, но в `href` попадают как есть, а React 17
// `javascript:` не режет. Пропускаем только ожидаемые схемы — это проверка
// формата, а не бизнес-ограничение.
const SLACK_APP_URL = /^slack:\/\//i;
const WEB_URL = /^https?:\/\//i;

/**
 * Строки `myGroupTeacherContacts` → контакты для кнопки «Napisz do prowadzącego».
 *
 * Порядок — серверный (по фамилии). Строка без ссылки на приложение Slack
 * кнопки не даёт и выпадает; веб-ссылка необязательна.
 */
export const transformTeacherContacts = (
  data: StudentGroupTeacherContactsQuery | undefined,
): ITeacherContact[] =>
  (data?.myGroupTeacherContacts ?? [])
    .filter((row) => SLACK_APP_URL.test(row.slackAppUrl ?? ''))
    .map((row) => ({
      teacherId: row.teacherId,
      fullName: (row.fullName ?? '').trim(),
      photo: row.photo || null,
      slackAppUrl: row.slackAppUrl,
      slackWebUrl: row.slackWebUrl && WEB_URL.test(row.slackWebUrl) ? row.slackWebUrl : null,
    }));
